import type * as lazyIndex from './lazyIndex';
import {
    LazyModule,
    createLazyComponent,
    registerLazyOrchestrator,
    LazyImport,
    LazyAction,
} from 'owa-bundling';
import { initializeSharedFolderRoots } from 'owa-folders';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/*webpackChunkName: "SharedFolders"*/ './lazyIndex'),
    { name: 'SharedFolders' }
);

export const LazySharedFolderPeoplePicker: typeof lazyIndex.SharedFolderPeoplePicker =
    createLazyComponent(lazyModule, m => m.SharedFolderPeoplePicker);
export const lazyShowSharedFolderPeoplePickerDialog: LazyAction<
    typeof lazyIndex.showSharedFolderPeoplePickerDialogMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showSharedFolderPeoplePickerDialogMutator);

export const lazyRemoveSharedFolderUser: LazyImport<
    typeof lazyIndex.removeSharedFolderUser,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeSharedFolderUser);
export const lazyAddSharedFolderUser: LazyAction<
    typeof lazyIndex.addSharedFolderUser,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addSharedFolderUser);
export const lazyAddImportedAdditionalMailboxes: LazyAction<
    typeof lazyIndex.addImportedAdditionalMailboxes,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addImportedAdditionalMailboxes);
export const lazyInitializeSharedFolderRetentionPolicyTags: LazyAction<
    typeof lazyIndex.initializeSharedFolderRetentionPolicyTags,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeSharedFolderRetentionPolicyTags);
export const lazySetSharedFolderMatchesAccount: LazyAction<
    typeof lazyIndex.setSharedFolderMatchesAccountMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setSharedFolderMatchesAccountMutator);

export const lazySetSharedFolderIsHidden: LazyAction<
    typeof lazyIndex.setSharedFolderIsHiddenMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setSharedFolderIsHiddenMutator);

registerLazyOrchestrator(
    initializeSharedFolderRoots,
    lazyModule,
    m => m.initializeSharedFolderRootsOrchestrator
);

export {
    selectDefaultFolderOnRemove,
    type SELECT_DEFAULT_FOLDERActionMessage,
} from './actions/selectDefaultFolderOnRemove';
export { SharedFolderRemoveLocation } from './constants';
